import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-magento1-reenable-compilation',
  template: require('./magento1_reenable_compilation.component.html'),
  styles: [require('./magento1_reenable_compilation.component.scss')]

})

export class Magento1ReenableCompilationComponent extends AccordionContentComponent {

}
